// Parse a receptionist's search input into a typed intent so the widget can
// route name vs mobile vs queue-number searches without forcing the user to
// remember the canonical "Q-N" form. Lives outside the component so it can
// be unit-tested in isolation.
//
// Returned shape — discriminated on `intent`:
//   { intent: 'empty' }
//   { intent: 'queue',         value: number }
//   { intent: 'mobile',        fragment: string }
//   { intent: 'queueOrMobile', value: number, fragment: string }
//   { intent: 'name',          text: string }
//
// Detection rules, evaluated top-to-bottom:
//   1. q-token (e.g. q1, Q1, Q-1, q 1, q_1) — strict queue match.
//   2. 4+ pure digits — mobile fragment; queue numbers don't realistically
//      reach 4 digits in a single clinic day.
//   3. 1-3 pure digits — ambiguous; could be the queue number or the start
//      of a mobile. Surface both so the caller can intersect/union as it
//      sees fit (the widget unions them and lets the typeahead disambiguate).
//   4. Anything else — name search, lowercased for case-insensitive match.

export function parseReceptionistQuery(raw) {
  const trimmed = typeof raw === 'string' ? raw.trim() : '';
  if (!trimmed) return { intent: 'empty' };

  const qMatch = trimmed.match(/^q[\s\-_]?(\d{1,4})$/i);
  if (qMatch) {
    return { intent: 'queue', value: Number(qMatch[1]) };
  }

  if (/^\d+$/.test(trimmed)) {
    if (trimmed.length >= 4) {
      return { intent: 'mobile', fragment: trimmed };
    }
    return {
      intent: 'queueOrMobile',
      value: Number(trimmed),
      fragment: trimmed,
    };
  }

  return { intent: 'name', text: trimmed.toLowerCase() };
}
